/*------------------------------------------------------------------------------
   About      : Responsible for managing configs
   
   Created on : Tue Jan 03 2023
   Author     : Siddharth Garg
   
   Copyright (c) 2023 Bidgely. All rights reserved.
------------------------------------------------------------------------------*/

import { RunContextApp }            from "framework/RCApp"

export class ConfigManager {

  // {[pilotId : string] : {[configType : string] : {[key : string] : any}}}
  private pilotLevelConfigs : {[key : string] : {[key : string] : {[key : string] : any}}} = {};
  
  constructor(private rc : RunContextApp) {
    
  }

  setConfigTypeData(pilotId : string, configsByType : {[key : string] : any}) {
  
    if (!this.pilotLevelConfigs[pilotId]) {
      this.pilotLevelConfigs[pilotId] = configsByType;

    } else {
      for (const configType in configsByType) {
        this.pilotLevelConfigs[pilotId][configType] = configsByType[configType];
      }
    }
  }

  addConfig(pilotId : string, configType : string, key : string, value : any) {

    if (!this.pilotLevelConfigs[pilotId][configType]) {
      this.pilotLevelConfigs[pilotId][configType] = {};
    }

    this.pilotLevelConfigs[pilotId][configType][key] = value;    
  }
  
  getAllConfigTypesForPilot(pilotId : string) {
    return this.pilotLevelConfigs[pilotId];
  }

  getConfigForType(pilotId : string, configType : string) {
    return this.pilotLevelConfigs[pilotId][configType];
  }

  getConfig(pilotId : string, configType : string, key : string) {
    return this.pilotLevelConfigs[pilotId][configType][key];
  }

  configTypeExists(pilotId : string, configType : string) {
    return this.pilotLevelConfigs[pilotId][configType] ? true : false;
  }
}